import { waitForPageLoadAnalytics } from "../pageLoad";
import getWindow from "../../utils/window";
import { getCommons, getGlobalEvars } from "../common";
import { setEvents, setLinkTrackEvents } from "../events";

const viewedProductIds = new Set();

export const resetWaysToStyleProductView = () => {
  viewedProductIds.clear();
};

export const fireWaysToStyleProductView = async ({ productId, index }) => {
  if (viewedProductIds.has(productId)) {
    return;
  }

  viewedProductIds.add(productId);

  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  const TRACKING_NAME = "waysToStyleProductView";

  s.products = `;${productId};;;;`;

  setEvents({
    events: ["event172"],
    trackingName: TRACKING_NAME,
  });

  s.eVar106 = `btl pop up|product|view_${index}`;

  s.tl(true, "o", "btl pop up product view", {
    linkTrackVars: commons.setLinkTrackVars([
      ...getGlobalEvars(),
      "eVar106",
      "products",
    ]),
    linkTrackEvents: setLinkTrackEvents({
      trackingName: TRACKING_NAME,
    }),
  });
};
